import { render, staticRenderFns } from "./NgDetail.vue?vue&type=template&id=101eb241&scoped=true&"
import script from "./NgDetail.vue?vue&type=script&lang=js&"
export * from "./NgDetail.vue?vue&type=script&lang=js&"
import style0 from "./NgDetail.vue?vue&type=style&index=0&id=101eb241&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101eb241",
  null
  
)

export default component.exports